import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAccount } from 'wagmi';
import { CheckCircle2, Circle, ListChecks } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/binding`;

export default function OperatorChecklist({ kypaId, wallet, refreshKey }) {
  const { address, isConnected } = useAccount();
  const [r, setR] = useState(null);
  const isOperator = isConnected && wallet && address?.toLowerCase() === wallet.toLowerCase();

  useEffect(() => {
    if (isOperator) axios.get(`${API}/operator-readiness/${encodeURIComponent(kypaId)}`).then((x) => setR(x.data)).catch(() => setR(null));
  }, [isOperator, kypaId, refreshKey]);

  if (!isOperator || !r) return null;
  const steps = [
    { key: 'allowlist', done: r.allowlist_count > 0, title: 'Set who may authorize this agent', detail: r.allowlist_count > 0 ? `${r.allowlist_count} wallet(s) on your private allowlist` : 'Until you sign a list, the gate refuses every real receipt for this agent.' },
    { key: 'posture', done: Boolean(r.posture), title: 'Sign a binding posture', detail: r.posture ? `Posture: ${r.posture.replace(/_/g, ' ')}` : 'Choose how far this agent may go on its own. It starts at Default Deny.' },
    { key: 'paid', done: r.paid_checks > 0, title: 'Run your first paid check', detail: r.paid_checks > 0 ? `${r.paid_checks} paid check(s) executed` : 'Route one real binding action through the paid gate ($0.10 USDC on Base). See the developer docs.' },
  ];
  const done = steps.filter((s) => s.done).length;
  return (
    <div className="mt-6 rounded-xl border border-emerald-500/25 bg-emerald-500/[0.04] p-4" data-testid="operator-checklist">
      <div className="flex items-center justify-between mb-3">
        <span className="flex items-center gap-2 text-sm font-semibold text-white"><ListChecks className="w-4 h-4 text-emerald-300" /> Operator setup</span>
        <span className="text-xs font-mono text-emerald-300" data-testid="operator-checklist-progress">{done} of 3 done</span>
      </div>
      <ol className="space-y-2.5">
        {steps.map((s) => (
          <li key={s.key} className="flex gap-2.5" data-testid={`operator-step-${s.key}`}>
            {s.done ? <CheckCircle2 className="w-4 h-4 shrink-0 text-emerald-300 mt-0.5" /> : <Circle className="w-4 h-4 shrink-0 text-gray-600 mt-0.5" />}
            <div>
              <div className={`text-xs font-semibold ${s.done ? 'text-gray-300' : 'text-white'}`}>{s.title}</div>
              <div className="text-[11px] text-gray-500" data-testid={`operator-step-${s.key}-detail`}>{s.detail}</div>
            </div>
          </li>
        ))}
      </ol>
      <p className="mt-3 text-[11px] text-gray-500">Only you see this checklist, because your wallet is this agent&rsquo;s registered wallet.</p>
    </div>
  );
}
